// Data-refresh orchestration shared by UI modules (kept free of DOM concerns
// except the pending-count badge, to avoid import cycles).
import { api } from './api';
import { state } from './state';

let payloadRequest = 0;
let payloadTimer: number | undefined;

/** Debounced payload load — scrubbing through frames coalesces requests. */
export function schedulePayload(): void {
  window.clearTimeout(payloadTimer);
  payloadTimer = window.setTimeout(() => void loadPayload(), 120);
}

export async function loadPayload(): Promise<void> {
  const frame = state.currentFrame;
  if (!frame) return;
  const req = ++payloadRequest;
  try {
    const payload = await api.framePolygons(frame.ms, state.admin);
    if (req !== payloadRequest || state.currentFrame?.ms !== payload.frame_ms) return; // stale
    state.payload = payload;
    if (state.selectedPolygonId !== null && !payload.polygons.some((p) => p.id === state.selectedPolygonId)) {
      state.selectedPolygonId = null;
    }
    state.emit('payload');
  } catch (err) {
    console.error('failed to load frame polygons', err);
  }
}

export async function refreshAnnotated(): Promise<void> {
  try {
    const rows = await api.annotated();
    state.annotated = new Map(rows.map((r) => [r.frame_ms, r.polygon_count]));
    state.emit('annotated');
  } catch (err) {
    console.error('failed to load annotated frames', err);
  }
}

export async function refreshPendingCount(): Promise<void> {
  const badge = document.getElementById('pendingCount');
  if (!badge) return;
  if (!state.admin) {
    badge.textContent = '0';
    return;
  }
  try {
    const items = await api.admin.pending();
    badge.textContent = String(items.length);
  } catch (err) {
    console.error('failed to load pending count', err);
  }
}
